module.exports = __webpack_public_path__ + "assets/img/smug.ec8455d3378b0c0abaad9cd3fffbdbf0.svg";